import { Home, BookOpen, BarChart3, User, Leaf, Sprout, Home as HomeIcon } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useMontessoriTheme } from '@/contexts/ThemeContext';

const standardItems = [
  { to: '/home',     icon: Home,      label: 'Home' },
  { to: '/journal',  icon: BookOpen,  label: 'Journal' },
  { to: '/insights', icon: BarChart3, label: 'Insights' },
  { to: '/profile',  icon: User,      label: 'Profile' },
];

const montessoriItems = [
  { to: '/home',              icon: Home,      label: 'Home' },
  { to: '/activities',        icon: Sprout,    label: 'Activities' },
  { to: '/sensitive-periods', icon: Leaf,      label: 'Periods' },
  { to: '/environment',       icon: HomeIcon,  label: 'Space' },
  { to: '/profile',           icon: User,      label: 'Profile' },
];

export default function BottomNav() {
  const loc = useLocation();
  const { isMontessori } = useMontessoriTheme();
  if (loc.pathname.startsWith('/onboarding')) return null;
  if (loc.pathname.startsWith('/milestone/')) return null;
  if (loc.pathname === '/privacy' || loc.pathname === '/terms') return null;
  if (loc.pathname === '/' || loc.pathname === '/auth' || loc.pathname === '/reset-password') return null;
  const items = isMontessori ? montessoriItems : standardItems;
  return (
    <nav className="fixed bottom-4 left-1/2 z-30 -translate-x-1/2">
      <div className="glass-lift flex items-center gap-1 px-2 py-2">
        {items.map(it => {
          const active = loc.pathname === it.to;
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              className="relative flex min-w-[58px] flex-col items-center gap-0.5 rounded-2xl px-2.5 py-2 text-[11px] font-medium text-muted-foreground transition-colors"
            >
              {active && (
                <motion.span
                  layoutId="nav-pill"
                  className="absolute inset-0 rounded-2xl bg-primary/15"
                  transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                />
              )}
              <Icon className={`relative h-5 w-5 ${active ? 'text-primary' : ''}`} strokeWidth={2.2} />
              <span className={`relative ${active ? 'text-primary' : ''}`}>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
